import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const LazyFooter = lazy(() => import('./components/Footer'));

function RootTemplate() {
  return (
    <div className="App">
      <Outlet />
      <Suspense fallback={<div>Loading Footer...</div>}>
        <LazyFooter />
      </Suspense>
    </div>
  );
}

export default RootTemplate;